/*暂定设计*/
// 关于这里的key 既代表code 也代表 页面路由的code 这样跳转不加任何处理
import { NIcon } from "naive-ui";
import { h } from "vue";
import {
  SlowMotionVideoFilled,
  FaceSharp,
  FileCopyOutlined,
  ProductionQuantityLimitsOutlined,
  ScreenSearchDesktopOutlined
} from "@vicons/material";
import {
  CloudSatelliteConfig,
  Template,
  AccumulationIce,
  AirlineRapidBoard,
  AssetConfirm
} from "@vicons/carbon";
import { DocumentVideo, ChartCombo, Stamp, ToolsAlt, } from "@vicons/carbon";
import { CheckupList } from "@vicons/tabler";
import { UserRegular } from "@vicons/fa";
import { CopyOutlined } from "@vicons/antd";
import { SettingsOutline, TvOutline } from "@vicons/ionicons5";


import {
  Sitemap,
  BuildingCommunity,
  Database,
  UserExclamation,
} from "@vicons/tabler";
import { ChartMultiple20Regular, TextBulletListLtr24Filled, ClipboardDataBar24Regular } from "@vicons/fluent";
import useStore from "@/config/pinia";
import { cloneDeep } from "lodash";

// @ts-ignore
function renderIcon(icon, params = {}) {
  return () => h(NIcon, { ...params }, { default: () => h(icon) });
}

export interface menuOptions {
  label: string;
  name: string;
  code?: string | string[];
  parendKey?: string;
  icon?: any;
  disabled?: boolean;
  key?: string;
  children?: menuOptions[];
}
const isMobile = window.screen.width > 320 && window.screen.width < 960;
const menuList: menuOptions[] = [
  // {
  //   label: "概览",
  //   name: "overivew",
  // },
  {
    label: "询量",
    name: "pollingMenu",
    key: "pollingMenu",
    // icon: isMobile ? renderIcon(Database) : null,
    icon: renderIcon(ScreenSearchDesktopOutlined),
    children: [
      {
        label: "询量",
        name: "inquiries",
        code: "ask-tool:project-page",
        // icon: renderIcon(Database),
        parendKey: "pollingMenu",
        key: "inquiries",
      },
    ],
  },
  {
    label: "辅助工具",
    name: "programList",
    key: "programList",
    // icon: isMobile ? renderIcon(Database) : null,
    icon: renderIcon(ToolsAlt),
    children: [
      {
        label: "节目单",
        name: "programList",
        code: "ask-tool:program-list",
        // icon: renderIcon(TextBulletListLtr24Filled),
        parendKey: "programList",
        key: "programList", //根据key跳转
      },
      {
        label: "排期计算",
        name: "schedulingList",
        code: "scheduling_calculation:page", //待调整
        // icon: renderIcon(TextBulletListLtr24Filled),
        parendKey: "schedulingList",
        key: "schedulingList", //根据key跳转
      },
    ],
  },
  {
    label: "项目结算",
    name: "orderData",
    key: "orderData",
    // icon: isMobile ? renderIcon(AssignmentTurnedInOutlined) : null,
    icon: renderIcon(CopyOutlined),
    children: [
      {
        label: "结算流程",
        name: "settlementProcess",
        code: "settlement_process:page",
        // icon: renderIcon(CopyOutlined),
        parendKey: "orderData",
        key: "settlementProcess", //根据key跳转
      },
      {
        label: "流量证明",
        name: "orderData",
        code: "ask-tool:proof",
        // icon: renderIcon(Stamp),
        parendKey: "orderData",
        key: "orderData", //根据key跳转
      },
    ],
  },
  {
    label: "录屏系统",
    name: "autoscreen",
    key: "autoscreen",
    // icon: isMobile ? renderIcon(Sitemap) : null,
    icon: renderIcon(DocumentVideo),
    children: [
      {
        label: "项目录屏",
        name: "commonTask",
        code: "auto-screen-project:page",
        parendKey: "autoscreen",
        key: "commonTask",
      },
      {
        label: "投前预览",
        name: "previewTask",
        code: "auto-screen-preview-task:page",
        parendKey: "autoscreen",
        key: "previewTask",
      },
      {
        label: "桌面配置",
        name: "desktopConfig",
        code: "desktop-config:page",
        parendKey: "autoscreen",
        key: "desktopConfig",
      },
      {
        label: "媒体资源库",
        name: "mediaResourceLibrary",
        code: "autoscreen-mediaresource:page",
        parendKey: "autoscreen",
        key: "mediaResourceLibrary",
      },
      {
        label: "广告主配置",
        name: "advertiserConfiguration",
        code: "autoscreen-advertiserconfig:page",
        parendKey: "autoscreen",
        key: "advertiserConfiguration",
      },
      {
        label: "录屏模板",
        name: "screenTemplate",
        code: "click-template:page",
        parendKey: "autoscreen",
        key: "screenTemplate",
      },
      {
        label: "场景参数配置",
        name: "sceneParameterConfiguration",
        code: "autoscreen-parameterconfig:page",
        parendKey: "autoscreen",
        key: "sceneParameterConfiguration",
      },
    ],
  },
  {
    label: "报表",
    name: "report",
    key: "report",
    // icon: isMobile ? renderIcon(Sitemap) : null,
    icon: renderIcon(ClipboardDataBar24Regular),
    children: [
      {
        label: "项目报表",
        name: "projectReport",
        code: "project-report:page",
        // icon: renderIcon(ChartCombo),
        parendKey: "report",
        key: "projectReport",
      },
      {
        label: "大盘报表",
        name: "largeMarket",
        code: "dashboard-report:export-page",
        // icon: renderIcon(ChartMultiple20Regular),
        parendKey: "report",
        key: "largeMarket",
      },
    ],
  },
  {
    label: "系统",
    name: "system",
    key: "system",
    // icon: isMobile ? renderIcon(UserRegular) : null,
    icon: renderIcon(SettingsOutline),
    children: [
      {
        label: "账户",
        name: "user",
        key: "user",
        code: "user:page",
        // icon: renderIcon(UserRegular, { size: 16 }),
        parendKey: "system",
      },
      {
        label: "角色",
        name: "role",
        key: "role",
        code: "role:page",
        // icon: renderIcon(FaceSharp),
        parendKey: "system",
      },
      // {
      //   label: "下单公司",
      //   name: "orderCompany",
      //   key: "orderCompany",
      //   code: "order-company:page",
      //   // icon: renderIcon(BuildingCommunity),
      //   parendKey: "system",
      // },
      {
        label: "广告主管理",
        name: "advertisers",
        key: "advertisers",
        code: "advertiserManage:list",
        // icon: renderIcon(UserExclamation),
        parendKey: "system",
      },
      {
        label: "代理公司",
        name: "agentCompany",
        key: "agentCompany",
        code: "company:list",
        // icon: renderIcon(BuildingCommunity),
        parendKey: "system",
      },
    ],
  },
  {
    label: "广告Demo",
    name: "demo",
    key: "demo",
    code: "ad-demo:page",
    icon: renderIcon(TvOutline, { size: 12 }),
  },
];
// 菜单逻辑（隐藏显示）
export const useMenuOption = () => {
  const store = useStore();

  const filterMenuItems = (items: any[]): any[] => {
    return items
      .filter((item: any) => {
        // 检查当前项是否有权限
        const hasPermission = store.getPower(item["code"]);
        // 如果有子项，递归检查子项
        if (item["children"] && item["children"].length) {
          item.children = filterMenuItems(item.children);
          // 如果子项有权限，则保留当前项
          return hasPermission || item.children.length > 0;
        }
        // 如果没有子项，直接检查当前项是否有权限
        return hasPermission;
      })
      .filter((item: any) => {
        // 确保子项不为空
        return !item["children"] || item.children.length > 0;
      });
  };

  let deepMenuList = cloneDeep(menuList);
  const result = filterMenuItems(deepMenuList);

  store.uploadMenu = false;
  return result;
};


